import type { CatalogKind } from '../../api/marketplace';
import { BrandMark } from '../../brand/BrandMark';
import { CATALOG_SHELVES } from '../../pages/CatalogPage';
import './SideDrawer.css';

interface SideDrawerProps {
  open: boolean;
  isAdmin: boolean;
  onClose: () => void;
  onOpenKind: (kind?: CatalogKind) => void;
  onOpenAdmin: () => void;
}

export function SideDrawer({ open, isAdmin, onClose, onOpenKind, onOpenAdmin }: SideDrawerProps) {
  return (
    <>
      <button
        type="button"
        className={`drawer-scrim${open ? ' drawer-scrim--open' : ''}`}
        aria-hidden={!open}
        tabIndex={open ? 0 : -1}
        onClick={onClose}
      />

      <aside className={`drawer${open ? ' drawer--open' : ''}`} aria-hidden={!open} aria-label="Разделы">
        <div className="drawer__brand">
          <BrandMark size="lg" stacked />
        </div>
        <p className="drawer__eyebrow">Витрина</p>

        {CATALOG_SHELVES.map((shelf) => (
          <button key={shelf.title} type="button" className="drawer__item" onClick={() => onOpenKind(shelf.id)}>
            <span className="drawer__item-title">{shelf.title}</span>
          </button>
        ))}

        {isAdmin ? (
          <>
            <p className="drawer__eyebrow">Служебное</p>
            <button type="button" className="drawer__item" onClick={onOpenAdmin}>
              <span className="drawer__item-title">Админка</span>
            </button>
          </>
        ) : null}
      </aside>
    </>
  );
}

export function MenuButton({ onClick }: { onClick: () => void }) {
  return (
    <button type="button" className="menu-button" onClick={onClick} aria-label="Открыть меню">
      <span />
      <span />
      <span />
    </button>
  );
}
